import React from "react";
import moment from "moment";
import { serverFormatWithTimezone } from "../../../utils/dates";

const DATE_FORMAT = "MM/DD/YYYY";
const DATE_INPUT_FORMATS = [
  DATE_FORMAT,
  "YYYY-MM-DD",
  serverFormatWithTimezone,
  "YYYY-MM-DDTHH:mm:ss Z",
  "YYYY-MM-DD HH:mm:ss UTC",
];

const formatDate = dateTime => {
  if (!dateTime) return "";

  const strictDate = moment(dateTime, DATE_INPUT_FORMATS, true);
  if (strictDate.isValid()) return strictDate.format(DATE_FORMAT);

  const fallbackDate = moment(dateTime);
  return fallbackDate.isValid() ? fallbackDate.format(DATE_FORMAT) : dateTime;
};

export default ({ value }) => <span>{formatDate(value)}</span>;
